import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    this.timer = setTimeout(() => this.refresh(), 10000)
  }

  async refresh() {
    if (document.hidden || this.element.querySelector("details[open]")) {
      this.schedule()
      return
    }

    const frame = this.element.closest("turbo-frame")
    try {
      if (frame.src) {
        frame.reload()
      } else {
        frame.src = this.urlValue
      }
      await frame.loaded
    } finally {
      if (this.element.isConnected) this.schedule()
    }
  }
}
